// AUTO-GENERATED (gen_hatch_i18n.py). Hatch-date calculator, 22 languages.
export const HATCH_GEN = {
 "fr": {
  "slug": "calculateur-date-eclosion",
  "title": "Calculateur de date d'éclosion | Ma Petite Ferme",
  "metaDescription": "Calculez gratuitement la date d'éclosion de vos œufs selon l'espèce et la date de mise en incubation : poules, canards, oies, cailles, dindes.",
  "h1": "Calculateur de date d'éclosion",
  "intro": "Indiquez l'espèce et la date de mise en incubation pour connaître la date d'éclosion prévue et les étapes clés : mirage et arrêt du retournement (mise en éclosoir).",
  "speciesLabel": "Espèce",
  "startLabel": "Date de mise en incubation",
  "resultTitle": "Dates clés",
  "hatchLabel": "Date d'éclosion prévue",
  "candlingLabel": "Mirage (contrôle des œufs)",
  "lockdownLabel": "Arrêt du retournement (éclosoir)",
  "daysLabel": "Durée d'incubation",
  "daysUnit": "jours",
  "disclaimer": "Estimation indicative. La durée réelle varie selon la race, la température et l'hygrométrie de l'incubateur.",
  "ctaTitle": "Suivez vos couvées avec Ma Petite Ferme",
  "ctaText": "Planifiez vos incubations, notez vos taux d'éclosion et gérez votre cheptel au quotidien.",
  "ctaBtn": "Créer ma ferme gratuitement",
  "sp_poules": "Poules",
  "sp_canards": "Canards",
  "sp_canardsbarbarie": "Canards de Barbarie",
  "sp_oies": "Oies",
  "sp_cailles": "Cailles",
  "sp_dindes": "Dindes",
  "sp_pintades": "Pintades",
  "sp_faisans": "Faisans"
 },
 "en": {
  "slug": "egg-hatching-date-calculator",
  "title": "Egg Hatching Date Calculator | Ma Petite Ferme",
  "metaDescription": "Free egg hatching date calculator by species and incubation start date: chickens, ducks, geese, quail, turkeys and more.",
  "h1": "Egg Hatching Date Calculator",
  "intro": "Enter the species and incubation start date to find your expected hatch date and key milestones: candling and lockdown.",
  "speciesLabel": "Species",
  "startLabel": "Incubation Start Date",
  "resultTitle": "Key Dates",
  "hatchLabel": "Expected Hatch Date",
  "candlingLabel": "Candling (egg check)",
  "lockdownLabel": "Lockdown (stop turning)",
  "daysLabel": "Incubation Period",
  "daysUnit": "days",
  "disclaimer": "Estimated timeline only. Actual duration may vary depending on breed, incubator temperature and humidity.",
  "ctaTitle": "Track Your Hatches with Ma Petite Ferme",
  "ctaText": "Plan your incubation cycles, log your hatch rates and manage your flock day to day.",
  "ctaBtn": "Create my farm for free",
  "sp_poules": "Chickens",
  "sp_canards": "Ducks",
  "sp_canardsbarbarie": "Muscovy Ducks",
  "sp_oies": "Geese",
  "sp_cailles": "Quail",
  "sp_dindes": "Turkeys",
  "sp_pintades": "Guinea Fowl",
  "sp_faisans": "Pheasants"
 },
 "it": {
  "slug": "calcolatore-data-schiusa",
  "title": "Calcolatore data di schiusa | Ma Petite Ferme",
  "metaDescription": "Calcola gratis la data di schiusa delle tue uova in base alla specie e alla data di messa in incubazione: galline, anatre, oche, quaglie, tacchini.",
  "h1": "Calcolatore della data di schiusa",
  "intro": "Indica la specie e la data di messa in incubazione per conoscere la data di schiusa prevista e le tappe fondamentali: speratura e blocco della rotazione (trasferimento in nascondiglio).",
  "speciesLabel": "Specie",
  "startLabel": "Data di messa in incubazione",
  "resultTitle": "Date chiave",
  "hatchLabel": "Data di schiusa prevista",
  "candlingLabel": "Speratura (controllo delle uova)",
  "lockdownLabel": "Blocco della rotazione (nascondiglio)",
  "daysLabel": "Durata di incubazione",
  "daysUnit": "giorni",
  "disclaimer": "Stima indicativa. La durata reale varia in base alla razza, alla temperatura e all'umidità dell'incubatore.",
  "ctaTitle": "Segui le tue covate con Ma Petite Ferme",
  "ctaText": "Pianifica le tue incubazioni, registra i tassi di schiusa e gestisci il tuo allevamento ogni giorno.",
  "ctaBtn": "Crea la mia fattoria gratuitamente",
  "sp_poules": "Galline",
  "sp_canards": "Anatre",
  "sp_canardsbarbarie": "Anatre mute",
  "sp_oies": "Oche",
  "sp_cailles": "Quaglie",
  "sp_dindes": "Tacchini",
  "sp_pintades": "Faraone",
  "sp_faisans": "Fagiani"
 },
 "es": {
  "slug": "calculadora-fecha-eclosion",
  "title": "Calculadora de fecha de eclosion | Ma Petite Ferme",
  "metaDescription": "Calcula gratis la fecha de eclosion de tus huevos segun la especie y la fecha de inicio de incubacion: gallinas, patos, ocas, codornices, pavos.",
  "h1": "Calculadora de fecha de eclosion",
  "intro": "Indica la especie y la fecha de inicio de incubacion para conocer la fecha de eclosion prevista y las etapas clave: ovoscopia y fin del volteo (transferencia a la nacedora).",
  "speciesLabel": "Especie",
  "startLabel": "Fecha de inicio de incubacion",
  "resultTitle": "Fechas clave",
  "hatchLabel": "Fecha de eclosion prevista",
  "candlingLabel": "Ovoscopia (control de los huevos)",
  "lockdownLabel": "Fin del volteo (nacedora)",
  "daysLabel": "Duracion de incubacion",
  "daysUnit": "dias",
  "disclaimer": "Estimacion orientativa. La duracion real varia segun la raza, la temperatura y la humedad de la incubadora.",
  "ctaTitle": "Lleva el seguimiento de tus incubaciones con Ma Petite Ferme",
  "ctaText": "Planifica tus incubaciones, registra tus tasas de eclosion y gestiona tu granja dia a dia.",
  "ctaBtn": "Crear mi granja gratis",
  "sp_poules": "Gallinas",
  "sp_canards": "Patos",
  "sp_canardsbarbarie": "Patos de Berberia",
  "sp_oies": "Ocas",
  "sp_cailles": "Codornices",
  "sp_dindes": "Pavos",
  "sp_pintades": "Pintadas",
  "sp_faisans": "Faisanes"
 },
 "de": {
  "slug": "schluepfdatum-rechner",
  "title": "Schlüpfdatum-Rechner | Ma Petite Ferme",
  "metaDescription": "Berechne kostenlos das Schlüpfdatum deiner Eier nach Tierart und Einlegedatum: Hühner, Enten, Gänse, Wachteln, Truthähne und mehr.",
  "h1": "Schlüpfdatum-Rechner",
  "intro": "Gib die Tierart und das Einlegedatum in den Brutapparat ein, um das voraussichtliche Schlüpfdatum und die wichtigsten Schritte zu erfahren: Schieren der Eier und Ende des Wendens (Übergang in den Schlüpfer).",
  "speciesLabel": "Tierart",
  "startLabel": "Einlegedatum in den Brutapparat",
  "resultTitle": "Wichtige Termine",
  "hatchLabel": "Voraussichtliches Schlüpfdatum",
  "candlingLabel": "Schieren (Kontrolle der Eier)",
  "lockdownLabel": "Ende des Wendens (Schlüpfer)",
  "daysLabel": "Brutdauer",
  "daysUnit": "Tage",
  "disclaimer": "Richtwert. Die tatsächliche Brutdauer kann je nach Rasse, Temperatur und Luftfeuchtigkeit im Brutapparat abweichen.",
  "ctaTitle": "Behalte deine Bruten im Blick mit Ma Petite Ferme",
  "ctaText": "Plane deine Brutgänge, erfasse deine Schlupfraten und verwalte deinen Tierbestand ganz einfach im Alltag.",
  "ctaBtn": "Meine Farm kostenlos erstellen",
  "sp_poules": "Hühner",
  "sp_canards": "Enten",
  "sp_canardsbarbarie": "Warzenenten",
  "sp_oies": "Gänse",
  "sp_cailles": "Wachteln",
  "sp_dindes": "Truthähner",
  "sp_pintades": "Perlhühner",
  "sp_faisans": "Fasane"
 },
 "nl": {
  "slug": "broeddatum-berekenen",
  "title": "Broeddatum berekenen | Ma Petite Ferme",
  "metaDescription": "Bereken gratis de uitkomstdatum van uw eieren op basis van de soort en inlegdatum: kippen, eenden, ganzen, kwartels, kalkoenen.",
  "h1": "Broeddatum berekenen",
  "intro": "Geef de soort en de inlegdatum op om de verwachte uitkomstdatum en de belangrijkste stappen te berekenen: schouwing en stop met draaien (overplaatsen naar uitkomster).",
  "speciesLabel": "Soort",
  "startLabel": "Inlegdatum",
  "resultTitle": "Belangrijke datums",
  "hatchLabel": "Verwachte uitkomstdatum",
  "candlingLabel": "Schouwing (controle van de eieren)",
  "lockdownLabel": "Stop met draaien (uitkomster)",
  "daysLabel": "Broedduur",
  "daysUnit": "dagen",
  "disclaimer": "Indicatieve schatting. De werkelijke duur varieert per ras, temperatuur en luchtvochtigheid in de broedmachine.",
  "ctaTitle": "Beheer uw broedsets met Ma Petite Ferme",
  "ctaText": "Plan uw broedrondes, registreer uw uitkomstpercentages en beheer uw pluimvee dagelijks.",
  "ctaBtn": "Maak gratis mijn boerderij aan",
  "sp_poules": "Kippen",
  "sp_canards": "Eenden",
  "sp_canardsbarbarie": "Muskuseenden",
  "sp_oies": "Ganzen",
  "sp_cailles": "Kwartels",
  "sp_dindes": "Kalkoenen",
  "sp_pintades": "Parelhoenders",
  "sp_faisans": "Fazanten"
 },
 "sv": {
  "slug": "kalkylator-klackningsdatum",
  "title": "Kalkylator för kläckningsdatum | Ma Petite Ferme",
  "metaDescription": "Beräkna gratis kläckningsdatumet för dina ägg utifrån art och startdatum för ruvningen: höns, ankor, gäss, vaktel, kalkoner.",
  "h1": "Kalkylator för kläckningsdatum",
  "intro": "Ange art och startdatum för ruvningen för att se beräknat kläckningsdatum och viktiga steg: ljusspaning och stopp av vändning (överflyttning till kläckare).",
  "speciesLabel": "Art",
  "startLabel": "Startdatum för ruvning",
  "resultTitle": "Viktiga datum",
  "hatchLabel": "Beräknat kläckningsdatum",
  "candlingLabel": "Ljusspaning (kontroll av äggen)",
  "lockdownLabel": "Stopp av vändning (kläckare)",
  "daysLabel": "Rusningstid",
  "daysUnit": "dagar",
  "disclaimer": "Beräkningen är vägledande. Den faktiska tiden varierar beroende på ras, temperatur och luftfuktighet i ruvaren.",
  "ctaTitle": "Följ dina kläckningar med Ma Petite Ferme",
  "ctaText": "Planera dina ruvningar, anteckna dina kläckningsresultat och sköt din djurbesättning i vardagen.",
  "ctaBtn": "Skapa min gård gratis",
  "sp_poules": "Höns",
  "sp_canards": "Ankor",
  "sp_canardsbarbarie": "Myskänder",
  "sp_oies": "Gäss",
  "sp_cailles": "Vaktlar",
  "sp_dindes": "Kalkoner",
  "sp_pintades": "Pärlhöns",
  "sp_faisans": "Fasaner"
 },
 "da": {
  "slug": "beregner-rugeklaekningsdato",
  "title": "Beregner for klækningsdato | Ma Petite Ferme",
  "metaDescription": "Beregn gratis klækningsdatoen for dine æg ud fra art og rugedato: høns, ænder, gæs, vagtler, kalkuner og mere.",
  "h1": "Beregner for klækningsdato",
  "intro": "Angiv art og rugedato for at få den forventede klækningsdato samt vigtige trin: lysning af æg og stop for vending (overflytning til klækkerum).",
  "speciesLabel": "Art",
  "startLabel": "Dato for start af rugning",
  "resultTitle": "Vigtige datoer",
  "hatchLabel": "Forventet klækningsdato",
  "candlingLabel": "Lysning (kontrol af æggene)",
  "lockdownLabel": "Stop for vending (klækkerum)",
  "daysLabel": "Rugetid",
  "daysUnit": "dage",
  "disclaimer": "Vejledende estimat. Den faktiske varighed varierer afhængigt af race, temperatur og luftfugtighed i rugemaskinen.",
  "ctaTitle": "Følg dine rugninger med Ma Petite Ferme",
  "ctaText": "Planlæg dine rugninger, registrer dine klækningsprocenter og administrer din besætning i hverdagen.",
  "ctaBtn": "Opret min gård gratis",
  "sp_poules": "Høns",
  "sp_canards": "Ænder",
  "sp_canardsbarbarie": "Moskusænder",
  "sp_oies": "Gæs",
  "sp_cailles": "Vagtler",
  "sp_dindes": "Kalkuner",
  "sp_pintades": "Perlehøns",
  "sp_faisans": "Fasaner"
 },
 "hr": {
  "slug": "kalkulator-datuma-izlijeganja",
  "title": "Kalkulator datuma izlijeganja jaja | Ma Petite Ferme",
  "metaDescription": "Besplatno izračunajte datum izlijeganja jaja prema vrsti ptice i datumu početka inkubacije: kokoši, patke, guske, prepelice, purani.",
  "h1": "Kalkulator datuma izlijeganja jaja",
  "intro": "Odaberite vrstu ptice i datum početka inkubacije kako biste saznali predviđeni datum izlijeganja i ključne korake: ovoskopiranje i prestanak okretanja jaja (premještanje u inkubator za izlijeganje).",
  "speciesLabel": "Vrsta",
  "startLabel": "Datum početka inkubacije",
  "resultTitle": "Ključni datumi",
  "hatchLabel": "Predviđeni datum izlijeganja",
  "candlingLabel": "Ovoskopiranje (kontrola jaja)",
  "lockdownLabel": "Prestanak okretanja (inkubator za izlijeganje)",
  "daysLabel": "Trajanje inkubacije",
  "daysUnit": "dana",
  "disclaimer": "Okvirna procjena. Stvarno trajanje ovisi o pasmini, temperaturi i vlažnosti unutar inkubatora.",
  "ctaTitle": "Pratite svoja legla uz Ma Petite Ferme",
  "ctaText": "Planirajte inkubacije, bilježite stope izlijeganja i upravljajte svojom farmom svaki dan.",
  "ctaBtn": "Kreirajte svoju farmu besplatno",
  "sp_poules": "Kokoši",
  "sp_canards": "Patke",
  "sp_canardsbarbarie": "Mošusne patke",
  "sp_oies": "Guske",
  "sp_cailles": "Prepelice",
  "sp_dindes": "Purani",
  "sp_pintades": "Biserke",
  "sp_faisans": "Fazani"
 },
 "bg": {
  "slug": "kalkulator-data-izlupvane",
  "title": "Калкулатор за дата на излюпване | Ma Petite Ferme",
  "metaDescription": "Изчислете безплатно датата на излюпване на яйцата си според вида птица и датата на поставяне в инкубатор: кокошки, патици, гъски, пъдпъдъци, пуйки.",
  "h1": "Калкулатор за дата на излюпване",
  "intro": "Посочете вида птица и датата на поставяне в инкубатор, за да разберете очакваната дата на излюпване и ключовите етапи: овоскопиране и спиране на обръщането (преместване в излюпник).",
  "speciesLabel": "Вид птица",
  "startLabel": "Дата на поставяне в инкубатор",
  "resultTitle": "Ключови дати",
  "hatchLabel": "Очаквана дата на излюпване",
  "candlingLabel": "Овоскопиране (контрол на яйцата)",
  "lockdownLabel": "Спиране на обръщането (излюпник)",
  "daysLabel": "Продължителност на инкубацията",
  "daysUnit": "дни",
  "disclaimer": "Приблизителна оценка. Реалната продължителност варира според породата, температурата и влажността в инкубатора.",
  "ctaTitle": "Следете люпилните си с Ma Petite Ferme",
  "ctaText": "Планирайте инкубациите си, записвайте процента на излюпване и управлявайте стопанството си всеки ден.",
  "ctaBtn": "Създай фермата си безплатно",
  "sp_poules": "Кокошки",
  "sp_canards": "Патици",
  "sp_canardsbarbarie": "Мускусни патици",
  "sp_oies": "Гъски",
  "sp_cailles": "Пъдпъдъци",
  "sp_dindes": "Пуйки",
  "sp_pintades": "Токачки",
  "sp_faisans": "Фазани"
 },
 "et": {
  "slug": "munemise-kuupeva-kalkulaator",
  "title": "Koorumiskuupäeva kalkulaator | Ma Petite Ferme",
  "metaDescription": "Arvuta tasuta munade koorumiskuupäev liigi ja inkubatsiooni alguskuupäeva järgi: kanad, pardid, haned, vutid, kalkunid.",
  "h1": "Koorumiskuupäeva kalkulaator",
  "intro": "Sisesta liik ja inkubatsiooni alguskuupäev, et teada saada eeldatav koorumiskuupäev ning põhietapid: läbivalgustamine ja pööramine lõpetamine (üleviimine koorumisinkubaatorisse).",
  "speciesLabel": "Liik",
  "startLabel": "Inkubatsiooni alguskuupäev",
  "resultTitle": "Olulised kuupäevad",
  "hatchLabel": "Eeldatav koorumiskuupäev",
  "candlingLabel": "Läbivalgustamine (munade kontroll)",
  "lockdownLabel": "Pööramine lõpetatakse (koorumisinкubaator)",
  "daysLabel": "Inkubatsiooniperiood",
  "daysUnit": "päeva",
  "disclaimer": "Ligikaudne hinnang. Tegelik kestus sõltub tõust, inkubaatori temperatuurist ja õhuniiskusest.",
  "ctaTitle": "Jälgi oma haudekordi Ma Petite Ferme'iga",
  "ctaText": "Planeeri inkubatsioone, märgi üles koorumismäärad ja halda oma karja igapäevaselt.",
  "ctaBtn": "Loo oma talu tasuta",
  "sp_poules": "Kanad",
  "sp_canards": "Pardid",
  "sp_canardsbarbarie": "Muskuspardid",
  "sp_oies": "Haned",
  "sp_cailles": "Vutid",
  "sp_dindes": "Kalkunid",
  "sp_pintades": "Pärlkanad",
  "sp_faisans": "Faasanid"
 },
 "fi": {
  "slug": "munapaivan-laskuri",
  "title": "Kuoriutumispäivän laskuri | Ma Petite Ferme",
  "metaDescription": "Laske ilmaiseksi munien kuoriutumispäivä lajin ja haudontaan asettamisen päivän mukaan: kanat, ankat, hanhet, viiriäiset, kalkkunat.",
  "h1": "Kuoriutumispäivän laskuri",
  "intro": "Valitse laji ja haudontaan asettamisen päivämäärä, niin saat arvioitu kuoriutumispäivän sekä tärkeimmät välivaiheet: kynttiläntarkastus ja kääntelyn lopetus (siirto kuoriutumislaatikkoon).",
  "speciesLabel": "Laji",
  "startLabel": "Haudontaan asettamisen päivämäärä",
  "resultTitle": "Tärkeät päivämäärät",
  "hatchLabel": "Arvioitu kuoriutumispäivä",
  "candlingLabel": "Kynttiläntarkastus (munien tarkistus)",
  "lockdownLabel": "Kääntelyn lopetus (kuoriutumislaatikko)",
  "daysLabel": "Haudonta-aika",
  "daysUnit": "päivää",
  "disclaimer": "Tulos on suuntaa antava arvio. Todellinen haudonta-aika vaihtelee rodun, lämpötilan ja haudontalaitteen kosteuden mukaan.",
  "ctaTitle": "Seuraa hautomiasi munia Ma Petite Ferme -sovelluksella",
  "ctaText": "Suunnittele haudontasi, kirjaa kuoriutumistulokset ja hallinnoi eläimiäsi päivittäin.",
  "ctaBtn": "Luo tilani ilmaiseksi",
  "sp_poules": "Kanat",
  "sp_canards": "Ankat",
  "sp_canardsbarbarie": "Myskiankat",
  "sp_oies": "Hanhet",
  "sp_cailles": "Viiriäiset",
  "sp_dindes": "Kalkkunat",
  "sp_pintades": "Helmikanalinnut",
  "sp_faisans": "Fasaanit"
 },
 "el": {
  "slug": "ypologistis-imerominias-ekkolaptisis",
  "title": "Υπολογιστής ημερομηνίας εκκόλαψης | Ma Petite Ferme",
  "metaDescription": "Υπολογίστε δωρεάν την ημερομηνία εκκόλαψης των αυγών σας ανά είδος και ημερομηνία τοποθέτησης: κότες, πάπιες, χήνες, ορτύκια, γαλοπούλες.",
  "h1": "Υπολογιστής ημερομηνίας εκκόλαψης",
  "intro": "Επιλέξτε το είδος και την ημερομηνία τοποθέτησης στον εκκολαπτήρα για να δείτε την αναμενόμενη ημερομηνία εκκόλαψης και τα βασικά στάδια: ωοσκόπηση και διακοπή αναστροφής (μεταφορά στον εκκολαπτήρα).",
  "speciesLabel": "Είδος",
  "startLabel": "Ημερομηνία τοποθέτησης στον εκκολαπτήρα",
  "resultTitle": "Βασικές ημερομηνίες",
  "hatchLabel": "Αναμενόμενη ημερομηνία εκκόλαψης",
  "candlingLabel": "Ωοσκόπηση (έλεγχος αυγών)",
  "lockdownLabel": "Διακοπή αναστροφής (μεταφορά στον εκκολαπτήρα)",
  "daysLabel": "Διάρκεια επώασης",
  "daysUnit": "ημέρες",
  "disclaimer": "Ενδεικτική εκτίμηση. Η πραγματική διάρκεια εξαρτάται από τη φυλή, τη θερμοκρασία και την υγρασία του εκκολαπτήρα.",
  "ctaTitle": "Παρακολουθήστε τις επωάσεις σας με το Ma Petite Ferme",
  "ctaText": "Σχεδιάστε τις επωάσεις σας, καταγράψτε τα ποσοστά εκκόλαψης και διαχειριστείτε το κοπάδι σας καθημερινά.",
  "ctaBtn": "Δημιουργήστε τη φάρμα μου δωρεάν",
  "sp_poules": "Κότες",
  "sp_canards": "Πάπιες",
  "sp_canardsbarbarie": "Πάπιες Βαρβαρίας",
  "sp_oies": "Χήνες",
  "sp_cailles": "Ορτύκια",
  "sp_dindes": "Γαλοπούλες",
  "sp_pintades": "Φραγκόκοτες",
  "sp_faisans": "Φασιανοί"
 },
 "hu": {
  "slug": "kelesi-datum-szamolo",
  "title": "Kelési dátum számológép | Ma Petite Ferme",
  "metaDescription": "Számítsd ki ingyen tojásaid kelési dátumát faj és berakási dátum alapján: tyúk, kacsa, lúd, fürj, pulyka. Gyors és egyszerű kelési naptár.",
  "h1": "Kelési dátum számológép",
  "intro": "Add meg a fajt és a berakási dátumot, hogy megtudd a várható kelési dátumot és a legfontosabb lépéseket: gyertyázás és a forgatás leállítása (keltetőbe helyezés).",
  "speciesLabel": "Faj",
  "startLabel": "Berakási dátum",
  "resultTitle": "Kulcsdátumok",
  "hatchLabel": "Várható kelési dátum",
  "candlingLabel": "Gyertyázás (tojásellenőrzés)",
  "lockdownLabel": "Forgatás leállítása (keltetőbe helyezés)",
  "daysLabel": "Keltetési időtartam",
  "daysUnit": "nap",
  "disclaimer": "Tájékoztató jellegű becslés. A tényleges időtartam a fajtától, a hőmérséklettől és a keltetőgép páratartalmától függően változhat.",
  "ctaTitle": "Kövesd nyomon a keltetetéseidet a Ma Petite Ferme-mel",
  "ctaText": "Tervezd meg a keltetetéseket, jegyezd fel a kelési arányokat, és kezeld állatállományodat nap mint nap.",
  "ctaBtn": "Hozd létre a farmom ingyen",
  "sp_poules": "Tyúkok",
  "sp_canards": "Kacsák",
  "sp_canardsbarbarie": "Pézsmakacsák",
  "sp_oies": "Libák",
  "sp_cailles": "Fürjek",
  "sp_dindes": "Pulykák",
  "sp_pintades": "Gyöngytyúkok",
  "sp_faisans": "Fácánok"
 },
 "pt": {
  "slug": "calculadora-data-eclosao",
  "title": "Calculadora de Data de Eclosão | Ma Petite Ferme",
  "metaDescription": "Calcule gratuitamente a data de eclosão dos seus ovos por espécie e data de incubação: galinhas, patos, gansos, codornas, perus.",
  "h1": "Calculadora de Data de Eclosão",
  "intro": "Indique a espécie e a data de início da incubação para conhecer a data de eclosão prevista e as etapas principais: ovoscopia e fim da viragem (transferência para o eclosário).",
  "speciesLabel": "Espécie",
  "startLabel": "Data de início da incubação",
  "resultTitle": "Datas importantes",
  "hatchLabel": "Data de eclosão prevista",
  "candlingLabel": "Ovoscopia (controlo dos ovos)",
  "lockdownLabel": "Fim da viragem (eclosário)",
  "daysLabel": "Duração da incubação",
  "daysUnit": "dias",
  "disclaimer": "Estimativa indicativa. A duração real varia conforme a raça, a temperatura e a humidade do incubador.",
  "ctaTitle": "Acompanhe as suas chocadas com a Ma Petite Ferme",
  "ctaText": "Planeie as suas incubações, registe as suas taxas de eclosão e gira o seu efetivo no dia a dia.",
  "ctaBtn": "Criar a minha quinta gratuitamente",
  "sp_poules": "Galinhas",
  "sp_canards": "Patos",
  "sp_canardsbarbarie": "Patos-de-barbária",
  "sp_oies": "Gansos",
  "sp_cailles": "Codornas",
  "sp_dindes": "Perus",
  "sp_pintades": "Pintadas",
  "sp_faisans": "Faisões"
 },
 "pl": {
  "slug": "kalkulator-daty-wyklucia",
  "title": "Kalkulator daty wyklucia jaj | Ma Petite Ferme",
  "metaDescription": "Oblicz bezpłatnie datę wyklucia jaj według gatunku i daty włożenia do inkubatora: kury, kaczki, gęsi, przepiórki, indyki.",
  "h1": "Kalkulator daty wyklucia jaj",
  "intro": "Podaj gatunek i datę włożenia jaj do inkubatora, aby poznać przewidywaną datę wyklucia oraz kluczowe etapy: prześwietlanie jaj i zatrzymanie obracania (przeniesienie do wylęgarki).",
  "speciesLabel": "Gatunek",
  "startLabel": "Data włożenia do inkubatora",
  "resultTitle": "Kluczowe daty",
  "hatchLabel": "Przewidywana data wyklucia",
  "candlingLabel": "Prześwietlanie (kontrola jaj)",
  "lockdownLabel": "Zatrzymanie obracania (wylęgarnia)",
  "daysLabel": "Czas inkubacji",
  "daysUnit": "dni",
  "disclaimer": "Wynik jest orientacyjny. Rzeczywisty czas inkubacji może się różnić w zależności od rasy, temperatury i wilgotności w inkubatorze.",
  "ctaTitle": "Zarządzaj swoimi lęgami z Ma Petite Ferme",
  "ctaText": "Planuj inkubacje, zapisuj wskaźniki wylęgu i prowadź swoją hodowlę na co dzień.",
  "ctaBtn": "Załóż swoją fermę bezpłatnie",
  "sp_poules": "Kury",
  "sp_canards": "Kaczki",
  "sp_canardsbarbarie": "Kaczki piżmowe",
  "sp_oies": "Gęsi",
  "sp_cailles": "Przepiórki",
  "sp_dindes": "Indyki",
  "sp_pintades": "Perliczki",
  "sp_faisans": "Bażanty"
 },
 "lt": {
  "slug": "kiausiniu-perejimo-datos-skaiciuokle",
  "title": "Kiaušinių perėjimo datos skaičiuoklė | Ma Petite Ferme",
  "metaDescription": "Nemokamai apskaičiuokite kiaušinių perėjimo datą pagal rūšį ir inkubacijos pradžią: vištos, antys, žąsys, putpelės, kalakutai.",
  "h1": "Kiaušinių perėjimo datos skaičiuoklė",
  "intro": "Pasirinkite paukščių rūšį ir inkubacijos pradžios datą, kad sužinotumėte numatytą perėjimo datą ir svarbiausius etapus: švietimą ir apvertimo sustabdymą (perkėlimą į peryklą).",
  "speciesLabel": "Rūšis",
  "startLabel": "Inkubacijos pradžios data",
  "resultTitle": "Pagrindinės datos",
  "hatchLabel": "Numatyta perėjimo data",
  "candlingLabel": "Švietimas (kiaušinių patikrinimas)",
  "lockdownLabel": "Apvertimo sustabdymas (perykla)",
  "daysLabel": "Inkubacijos trukmė",
  "daysUnit": "dienos",
  "disclaimer": "Apytikslis įvertinimas. Tikroji trukmė gali skirtis priklausomai nuo veislės, inkubatoriaus temperatūros ir drėgmės.",
  "ctaTitle": "Sekite savo perėjimus su Ma Petite Ferme",
  "ctaText": "Planuokite inkubacijas, fiksuokite perėjimo rodiklius ir valdykite savo ūkį kasdien.",
  "ctaBtn": "Sukurti savo ūkį nemokamai",
  "sp_poules": "Vištos",
  "sp_canards": "Antys",
  "sp_canardsbarbarie": "Muskusinės antys",
  "sp_oies": "Žąsys",
  "sp_cailles": "Putpelės",
  "sp_dindes": "Kalakutai",
  "sp_pintades": "Perllinės vištos",
  "sp_faisans": "Fazanai"
 },
 "lv": {
  "slug": "inkubacijas-datuma-kalkulators",
  "title": "Inkubācijas datuma kalkulators | Ma Petite Ferme",
  "metaDescription": "Aprēķiniet putnu olu izšķilšanās datumu bez maksas pēc sugas un inkubācijas sākuma datuma: vistas, pīles, zosis, paipala, tītari.",
  "h1": "Olu izšķilšanās datuma kalkulators",
  "intro": "Norādiet sugu un inkubācijas sākuma datumu, lai uzzinātu paredzamo izšķilšanās datumu un galvenos posmus: ovoskopēšanu un pagriezienu pārtraukšanu (pārvietošanu uz izšķilšanās inkubatoru).",
  "speciesLabel": "Suga",
  "startLabel": "Inkubācijas sākuma datums",
  "resultTitle": "Galvenie datumi",
  "hatchLabel": "Paredzamais izšķilšanās datums",
  "candlingLabel": "Ovoskopēšana (olu pārbaude)",
  "lockdownLabel": "Pagriezienu pārtraukšana (izšķilšanās inkubators)",
  "daysLabel": "Inkubācijas ilgums",
  "daysUnit": "dienas",
  "disclaimer": "Aptuvens aprēķins. Faktiskais ilgums var atšķirties atkarībā no šķirnes, inkubatora temperatūras un mitruma.",
  "ctaTitle": "Sekojiet saviem perējumiem ar Ma Petite Ferme",
  "ctaText": "Plānojiet inkubācijas, reģistrējiet izšķilšanās rādītājus un pārvaldiet savu ganāmpulku katru dienu.",
  "ctaBtn": "Izveidot savu fermu bez maksas",
  "sp_poules": "Vistas",
  "sp_canards": "Pīles",
  "sp_canardsbarbarie": "Muskuspīles",
  "sp_oies": "Zosis",
  "sp_cailles": "Paipalas",
  "sp_dindes": "Tītari",
  "sp_pintades": "Pērļu vistiņas",
  "sp_faisans": "Fazāni"
 },
 "ro": {
  "slug": "calculator-data-eclozare-oua",
  "title": "Calculator data eclozare oua | Ma Petite Ferme",
  "metaDescription": "Calculeaza gratuit data eclozarii oualor dupa specie si data incubarii: gaini, rate, gaste, prepelite, curci. Rezultat instant si etape cheie.",
  "h1": "Calculator data eclozare oua",
  "intro": "Selecteaza specia si data la care ai pus ouale la incubat pentru a afla data eclozarii estimate si etapele importante: ovoscoparea si oprirea intoarcerii (transferul in eclozator).",
  "speciesLabel": "Specia",
  "startLabel": "Data inceperii incubatiei",
  "resultTitle": "Date cheie",
  "hatchLabel": "Data eclozarii estimate",
  "candlingLabel": "Ovoscopare (control oua)",
  "lockdownLabel": "Oprirea intoarcerii (eclozator)",
  "daysLabel": "Durata incubatiei",
  "daysUnit": "zile",
  "disclaimer": "Estimare orientativa. Durata reala variaza in functie de rasa, temperatura si umiditatea din incubator.",
  "ctaTitle": "Urmareste-ti clocitele cu Ma Petite Ferme",
  "ctaText": "Planifica incubatiile, noteaza ratele de eclozare si gestioneaza efectivul de pasari zi de zi.",
  "ctaBtn": "Creeaza-mi ferma gratuit",
  "sp_poules": "Gaini",
  "sp_canards": "Rate",
  "sp_canardsbarbarie": "Rate de Barbarie",
  "sp_oies": "Gaste",
  "sp_cailles": "Prepelite",
  "sp_dindes": "Curci",
  "sp_pintades": "Bibilici",
  "sp_faisans": "Fazani"
 },
 "sk": {
  "slug": "kalkulator-datum-vyliahnutia",
  "title": "Kalkulator dátumu vyliahnutia | Ma Petite Ferme",
  "metaDescription": "Vypočítajte zadarmo dátum vyliahnutia vajec podľa druhu a dátumu vloženia do liaheň: sliepky, kačky, husi, prepelice, morky.",
  "h1": "Kalkulator dátumu vyliahnutia vajec",
  "intro": "Zadajte druh hydiny a dátum vloženia vajec do liaheň, aby ste zistili predpokladaný dátum vyliahnutia a kľúčové kroky: presvietenie vajec a zastavenie otáčania (presun do liahne).",
  "speciesLabel": "Druh",
  "startLabel": "Dátum vloženia do liaheň",
  "resultTitle": "Kľúčové dátumy",
  "hatchLabel": "Predpokladaný dátum vyliahnutia",
  "candlingLabel": "Presvietenie vajec (kontrola)",
  "lockdownLabel": "Zastavenie otáčania (liahňa)",
  "daysLabel": "Doba inkubácie",
  "daysUnit": "dní",
  "disclaimer": "Orientačný odhad. Skutočná doba sa líši podľa plemena, teploty a vlhkosti v liaheň.",
  "ctaTitle": "Sledujte svoje chovy s Ma Petite Ferme",
  "ctaText": "Plánujte inkubácie, zaznamenávajte mieru vyliahnutia a spravujte svoj chov každý deň.",
  "ctaBtn": "Vytvoriť moju farmu zadarmo",
  "sp_poules": "Sliepky",
  "sp_canards": "Kačky",
  "sp_canardsbarbarie": "Pižmové kačky",
  "sp_oies": "Husi",
  "sp_cailles": "Prepelice",
  "sp_dindes": "Morky",
  "sp_pintades": "Perlička",
  "sp_faisans": "Bažanty"
 },
 "sl": {
  "slug": "kalkulator-datuma-izvalitve",
  "title": "Kalkulator datuma izvalitve | Ma Petite Ferme",
  "metaDescription": "Brezplačno izračunajte datum izvalitve jajc glede na vrsto ptice in datum vložitve v valilnik: kokoši, race, gosi, prepelice, purani.",
  "h1": "Kalkulator datuma izvalitve jajc",
  "intro": "Izberite vrsto ptice in datum vložitve jajc v valilnik, da izveste predviden datum izvalitve ter ključne mejnike: prosvetljevanje jajc in ustavitev obračanja (prestavljanje v izvalilnik).",
  "speciesLabel": "Vrsta ptice",
  "startLabel": "Datum vložitve v valilnik",
  "resultTitle": "Ključni datumi",
  "hatchLabel": "Predviden datum izvalitve",
  "candlingLabel": "Prosvetljevanje (kontrola jajc)",
  "lockdownLabel": "Ustavitev obračanja (izvalilnik)",
  "daysLabel": "Trajanje inkubacije",
  "daysUnit": "dni",
  "disclaimer": "Okvirna ocena. Dejansko trajanje se razlikuje glede na pasmo, temperaturo in vlažnost v valilniku.",
  "ctaTitle": "Sledite svojemu valjenju z Ma Petite Ferme",
  "ctaText": "Načrtujte inkubacije, beležite stopnje izvalitve in upravljajte svojo živinorejo vsak dan.",
  "ctaBtn": "Ustvari svojo kmetijo brezplačno",
  "sp_poules": "Kokoši",
  "sp_canards": "Race",
  "sp_canardsbarbarie": "Barbarske race",
  "sp_oies": "Gosi",
  "sp_cailles": "Prepelice",
  "sp_dindes": "Purani",
  "sp_pintades": "Pegatke",
  "sp_faisans": "Fazani"
 },
 "cs": {
  "slug": "kalkulator-data-vylihnut",
  "title": "Kalkulátor data vylíhnutí | Ma Petite Ferme",
  "metaDescription": "Vypočítejte zdarma datum vylíhnutí vajec podle druhu a data nasazení do líhně: slepice, kachny, husy, křepelky, krůty.",
  "h1": "Kalkulátor data vylíhnutí vajec",
  "intro": "Zadejte druh ptáka a datum nasazení vajec do líhně a zjistěte předpokládané datum vylíhnutí i klíčové mezníky: prosvěcování vajec a ukončení otáčení.",
  "speciesLabel": "Druh",
  "startLabel": "Datum nasazení do líhně",
  "resultTitle": "Klíčová data",
  "hatchLabel": "Předpokládané datum vylíhnutí",
  "candlingLabel": "Prosvěcování (kontrola vajec)",
  "lockdownLabel": "Ukončení otáčení (přesun do líhniště)",
  "daysLabel": "Délka inkubace",
  "daysUnit": "dní",
  "disclaimer": "Orientační odhad. Skutečná délka inkubace se liší podle plemene, teploty a vlhkosti v líhni.",
  "ctaTitle": "Sledujte svá hnízdění s Ma Petite Ferme",
  "ctaText": "Plánujte inkubace, zaznamenávejte líhnivost a spravujte svůj chov každý den.",
  "ctaBtn": "Vytvořit svůj chov zdarma",
  "sp_poules": "Slepice",
  "sp_canards": "Kachny",
  "sp_canardsbarbarie": "Pižmové kachny",
  "sp_oies": "Husy",
  "sp_cailles": "Křepelky",
  "sp_dindes": "Krůty",
  "sp_pintades": "Perličky",
  "sp_faisans": "Bažanti"
 }
};
